import cortesConstruction from 'assets/images/clients/cortes_construction.png';
import fgg from 'assets/images/clients/fgg.png';
import khaleidaHealth from 'assets/images/clients/khaleida_health.png';
import limitless from 'assets/images/clients/limitless.png';
import pbdWorld from 'assets/images/clients/pbd-world.png';
import permatech from 'assets/images/clients/permatech.png';
import sealDesign from 'assets/images/clients/seal_design.png';
import techniWeld from 'assets/images/clients/techni-weld.png';
import theBuffaloNews from 'assets/images/clients/the-buffalo-news.png';
import westHerr from 'assets/images/clients/west-herr.png';
import wonder from 'assets/images/clients/wonder.png';

const items = [
  sealDesign,
  khaleidaHealth,
  cortesConstruction,
  westHerr,
  permatech,
  pbdWorld,
  fgg,
  wonder,
  techniWeld,
  limitless,
  theBuffaloNews
];

export default items;
